import { registerPlugin } from '@capacitor/core';

import { OtpFill } from './types';

export const OtpFillPlugin = registerPlugin<OtpFill>('OtpFill', {
  web: () => import('./web').then((m) => new m.OtpFillWebPlugin()),
  ios: () => import('./ios').then((m) => new m.OtpFilliOSPlugin()),
});
